// Import necessary Material-UI components
import { TableContainer, Paper } from "@mui/material";

/**
 * CustomMUITableContainer component for a TableContainer with custom styling
 * @param {Object} props - Component props including data, and callbacks.
 */
export function CustomMUITableContainer({ children }) {
  return (
    <TableContainer
      component={Paper}
      sx={{
        borderRadius: "10px",
        boxShadow: "rgba(0, 0, 0, 0.15) 0px 2px 8px",
      }}
    >
      {/* Render any child components passed to CustomMUITableContainer */}
      {children}
    </TableContainer>
  );
}
